import {
  Box, Button, Container, Stack,
} from '@mui/material';
import React, { useContext, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Colors from '../../../../Configs/colors';
import Images from '../../../../Configs/images';
import AlertContext from '../../../../Context/AlertContext';
import Elements from '../../../Elements';

export default function Component({
  classes, error, message,
}) {
  const navigate = useNavigate();
  const { id } = useParams();

  const { openAlert } = useContext(AlertContext);

  useEffect(() => {
    if (error) {
      openAlert({
        message: `Something went wrong. ${message}`,
        severity: 'error',
      });
    }
  }, [error]);

  return (
    <Elements.PageBase navigate={navigate} noNav>
      <Container className={classes.root}>
        <Elements.Navigator title="Detail history" />
        <Box className="center" mt={3}>
          <img alt="type" src={Images.IconSubscription} />
          <Box className="s-12 weight-700" mt={1.5}>Renewal reguler subscription</Box>
        </Box>
        <Box borderTop="1px dashed #E5E5E5" borderBottom="1px dashed #E5E5E5" py={2} my={2}>
          <Stack direction="column" gap={1.5}>
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <Box className="s-12">Payment method</Box>
              <Box className="s-12 weight-700">Stripe</Box>
            </Box>
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <Box className="s-12">Payment date</Box>
              <Box className="s-12 weight-700">12 august 2022, 10:15 AM</Box>
            </Box>
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <Box className="s-12">Status</Box>
              <Box className="s-12 weight-700" color="#38AC3D">Success</Box>
            </Box>
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <Box className="s-12">Order date</Box>
              <Box className="s-12 weight-700">12 august 2022, 10:12 AM</Box>
            </Box>
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <Box className="s-12">Order subscription ID</Box>
              <Box className="s-12 weight-700">N123456</Box>
            </Box>
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <Box className="s-12">Transcation ID</Box>
              <Box className="s-12 weight-700">{id}</Box>
            </Box>
          </Stack>
        </Box>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box className="s-12 weight-700">Price total</Box>
          <Box className="s-12 weight-700" color={Colors.primary}>$120</Box>
        </Box>

        <Button className="btn-outlined" variant="outlined" fullWidth size="small" sx={{ mt: 3 }}>
          <img src={Images.Download} alt="download" width="20" height="20" style={{ marginRight: 8 }} />
          Download invoice
        </Button>
      </Container>

      <Elements.Footer />
    </Elements.PageBase>
  );
}
